export default __webpack_public_path__ + "static/media/gateway_sip.189918e8.jpg";